import { render, staticRenderFns } from "./ToysMain.vue?vue&type=template&id=2c1e1f17&"
import script from "./ToysMain.vue?vue&type=script&lang=js&"
export * from "./ToysMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports